import React, { useState } from "react";
import { fetchComType } from "./Services/fetchComType";
import { fetchRole } from "./Services/fetchRole";
import { fetchCompany } from "./Services/fetchCompany";
import { fetchCompany1 } from "./Services/fetchCompany";
import { updateCompany } from "./Services/updateCompany";
import { useEffect, useRef } from "react";
import { CompanyModuleService } from "./Services/companyModuleService";
import { CompanyNotiService } from "./Services/companyNotiService";
const CompanySetting = () => {
  useEffect(() => {
    const scriptUrls = [
      'assets/js/jquery.min.js',
      'assets/js/bootstrap.bundle.min.js',
      'assets/js/moment.min.js',
      'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
      'assets/vendor/overlay-scroll/custom-scrollbar.js',
      'assets/vendor/daterange/daterange.js',
      'assets/vendor/daterange/custom-daterange.js',
      'assets/js/custom.js'
    ];

    let isCancelled = false;

    // Load scripts sequentially
    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
      // Optionally remove scripts if needed
    };
  }, []);

  // for showing and updating data code
  const [comFetchId, setComFetchId] = useState(null);
  const [companies, setCompanies] = useState([]);
  const getCompanies = () => {
    const fetch = async () => {
      const data = await fetchCompany();
      setCompanies(data);
    };
    fetch();
  }
  const [companies1, setCompanies1] = useState([]);
  /* useEffect(() => {
      const getCompany = async () => {
        const data = await fetchCompany1(comFetchId);
        setCompanies1(data);
      };
  
      getCompany();
    }, [comFetchId]); */

  const [roles, setRoles] = useState([]);
  const [companyTypes, setCompanyTypes] = useState([]);
  const getRoles = () => {
    const fetch = async () => {
      const data = await fetchRole();
      setRoles(data);
    };
    fetch();
  }
  const getCompanyTypes = () => {
    const fetch = async () => {
      const data = await fetchComType();
      setCompanyTypes(data);
    }
    fetch();
  }
  useEffect(() => {
    getRoles();
    getCompanyTypes();
    getCompanies();
  }, []);

  const [editCompanyName, setEditCompanyName] = useState("");
  const [editComTypeId, setEditComTypeId] = useState(null);
  const [editCompanyIdPrefix, setEditCompanyIdPrefix] = useState("");
  const [editCompanyIdNo, setEditCompanyIdNo] = useState("");
  const [editCompanyRegNo, setEditCompanyRegNo] = useState("");
  const [editCompanyGstNo, setEditCompanyGstNo] = useState("");
  const [editLogoImg, setEditLogoImg] = useState(null);
  const [editOfficeAddress, setEditOfficeAddress] = useState("");
  const [editBranchLocation, setEditBranchLocation] = useState("");
  const [editPhoneNumber, setEditPhoneNumber] = useState("");
  const [editEmailAddress, setEditEmailAddress] = useState("");
  const [editWebsiteUrl, setEditWebsiteUrl] = useState("");
  const [editEmergencyContact, setEditEmergencyContact] = useState("");
  const [editPrimaryPerson, setEditPrimaryPerson] = useState("");
  const [editRolesId, setEditRolesId] = useState(null);
  const [editPriPersonContactNo, setEditPriPersonContactNo] = useState("");
  const [comEditPassword, setEditComPassword] = useState("");
  const [comEditConPassword, setEditComConPassword] = useState("");
  const [bufferLogoImg, setBufferLogoImg] = useState("");


  const handleFileChange = (e) => {
    setEditLogoImg(e.target.files[0]);
  };

  const handleDropdownChange = (e) => {
    setEditComTypeId(e.target.value);
    // Don't reset or reload any state unnecessarily here
  };

        const handleRoleChange = (e) => {
          setEditRolesId(e.target.value);
          // Don't reset or reload any state unnecessarily here
        };
        const handleCompanyChange = (e) => {
          setComFetchId(e.target.value);
        };
        const fetchSelectedCompany = async (cId) => {
          if (cId) {
            const data = await fetchCompany1(cId);
      
            if (data) {
              setEditCompanyName(data.companyName);
              setEditComTypeId(data.companyTypeId);
              setEditCompanyIdPrefix(data.companyIdPrefix);
              setEditCompanyIdNo(data.companyIdNo);
              setEditCompanyRegNo(data.companyRegNo);
              setEditCompanyGstNo(data.companyGstNo);
              setBufferLogoImg(data.logoImg);
              setEditOfficeAddress(data.officeAddress);
              setEditBranchLocation(data.branchLocation);
              setEditPhoneNumber(data.phoneNumber);
              setEditEmailAddress(data.emailAddress);
              setEditWebsiteUrl(data.websiteUrl);
              setEditEmergencyContact(data.emergencyContact);
              setEditPrimaryPerson(data.primaryPerson);
              setEditRolesId(data.rolesId);
              setEditPriPersonContactNo(data.priPersonContactNo);
              setEditComPassword(data.companyPassword);
            }
          }
        };
      
        useEffect(() => {
         
          fetchSelectedCompany(comFetchId);
        }, [comFetchId]);
        const fileInputRef = useRef(null);
        const handleEdit = async (event) => {
          event.preventDefault();
          const formData = new FormData();
           if (!editCompanyName || !editComTypeId || !editCompanyIdPrefix || !editCompanyIdNo
            || !editCompanyRegNo || !editCompanyGstNo || !bufferLogoImg || !editOfficeAddress
            || !editBranchLocation || !editPhoneNumber || !editEmailAddress || !editWebsiteUrl
            || !editEmergencyContact || !editPrimaryPerson || !editRolesId || !editPriPersonContactNo
           ) {
             alert("Please fill in all required fields.");
             return;
           }
           formData.append("companyId", comFetchId);
           formData.append("companyName", editCompanyName);
           formData.append("companyTypeId", editComTypeId);
           formData.append("companyIdPrefix", editCompanyIdPrefix);
           formData.append("companyIdNo", editCompanyIdNo);
           formData.append("companyRegNo", editCompanyRegNo);
           formData.append("companyGstNo", editCompanyGstNo);
           if(editLogoImg){
            formData.append("logoImg", editLogoImg);
           }
           
           formData.append("officeAddress", editOfficeAddress);
           formData.append("branchLocation", editBranchLocation);
           formData.append("phoneNumber", editPhoneNumber);
           formData.append("emailAddress", editEmailAddress);
           formData.append("websiteUrl", editWebsiteUrl);
           formData.append("emergencyContact", editEmergencyContact);
           formData.append("primaryPerson", editPrimaryPerson);
           formData.append("rolesId", editRolesId);
           formData.append("priPersonContactNo", editPriPersonContactNo);
           formData.append("bufferLogoImg", bufferLogoImg);
           formData.append("companyPassword", comEditPassword);
           
           try {
             await updateCompany(formData);
             fetchSelectedCompany(comFetchId);
             if (fileInputRef.current) {
              fileInputRef.current.value = null; // this clears the file
            }
             getCompanies(); // refresh table data
           } catch (err) {
             alert("Failed to update company");
           }
         };
      
      // ending here
      //Modeles Story Start Here
      const [modules, setModules] = useState([]);

  // Fetch and sync modules
  const loadModules = async () => {
    try {
      await CompanyModuleService.syncModulesForCompany(comFetchId);
      await CompanyModuleService.updateDeletedFlags(comFetchId);
      const response = await CompanyModuleService.getModulesByCompany(comFetchId);
      const rawData = response.data.data;
      const flatData = rawData.flat();
      setModules(flatData);
    } catch (error) {
      console.error('Error loading company modules:', error);
    }
  };

  useEffect(() => {
    if (comFetchId) {
      loadModules();
    }
  }, [comFetchId]);

  // Toggle enable/disable

  const handleToggle = async (id, currentStatus) => {
    try {
      await CompanyModuleService.updateCompanyModuleStatus(id, currentStatus);
      // Update local state
      loadModules();
    } catch (error) {
      console.error('Error updating module status:', error);
    }
  };
  //Modules Story End Here
  // Notifications Story Starts Here
  const [notis, setNotis] = useState([]);

  // Fetch and sync modules
  const loadNotis = async () => {
    try {
      await CompanyNotiService.syncNotiForCompany(comFetchId);
      await CompanyNotiService.updateDeletedFlags(comFetchId);
      const response = await CompanyNotiService.getNotisByCompany(comFetchId);
      const rawData = response.data.data;
      const flatData = rawData.flat();
      setNotis(flatData);
    } catch (error) {
      console.error('Error loading company notifications:', error);
    }
  };

  useEffect(() => {
    if (comFetchId) {
      loadNotis();
    }
  }, [comFetchId]);

  // Toggle enable/disable

  const handleNotiToggle = async (id, currentStatus) => {
    try {
  
      await CompanyNotiService.updateCompanyNotiStatus(id, currentStatus);
      // Update local state
     
     loadNotis();
    } catch (error) {
      console.error('Error updating notifications status:', error);
    }
  };


  // Notifications Story Ends Here
  const [selectedTab, setSelectedTab] = useState('');

  const renderTabContent = () => {
    switch (selectedTab) {
      case 'whatsapp':
        return (
          <div className="tab-pane fade show active" id="sixA" role="tabpanel">
            {/* Row starts */}
            <div className="row gx-4">
              <div className="col-xxl-12 col-lg-12 col-sm-12">
                <div className="mb-12">
                  <h6>Key Details</h6>
                  <hr />
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a1">Phone Number Id<span className="text-danger">*</span></label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ri-account-circle-line" />
                    </span>
                    <input type="text" className="form-control" id="wan" placeholder="Whatsapp no" title="WhatsApp Business API phone number ID" />
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a2">WhatsApp Number <span className="text-danger">*</span></label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ri-account-circle-line" />
                    </span>
                    <input type="text" className="form-control" id="wapno" placeholder="Whatsapp no" title="Sender phone number" />
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a31">Access Token<span className="text-danger">*</span></label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ri-flower-line" />
                    </span>
                    <input type="text" className="form-control" id="at" placeholder="access token" title="API token for authentication (secure this!)" />
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="a4">Version <span className="text-danger">*</span></label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ri-flower-line" />
                    </span>
                    <input type="text" className="form-control" id="av" placeholder="Version" />
                  </div>
                </div>
              </div>
              <div className="d-flex gap-2 justify-content-end">
                <button type="button" className="btn btn-secondary">
                  Cancel
                </button>
                <button type="button" className="btn btn-primary">
                  Update
                </button>
              </div>
            </div>
            {/* Row ends */}
          </div>
        );
      case 'email':
        return (

          <div className="tab-pane fade show active" id="EmailA" role="tabpanel">
            {/* Row starts */}
            <div className="row gx-4">
              <div className="col-xxl-12 col-lg-12 col-sm-12">
                <div className="mb-12">
                  <h6>Key Details</h6>
                  <hr />
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="mid">Message Id<span className="text-danger">*</span></label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ri-account-circle-line" />
                    </span>
                    <input type="text" className="form-control" id="mids" placeholder="Message Id" title="Gmail API’s unique message ID (after send)" />
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="threadId">Threads Id <span className="text-danger">*</span></label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ri-account-circle-line" />
                    </span>
                    <input type="text" className="form-control" id="threadIds" placeholder="Thread Id" title="Gmail thread/conversation ID" />
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="DefaultSub">Default Subjects<span className="text-danger">*</span></label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ri-flower-line" />
                    </span>
                    <input type="email" className="form-control" id="DefaultSub" placeholder="Default Subjects" title="Default Subjets" />
                  </div>
                </div>
              </div>
              <div className="col-xxl-12 col-lg-12 col-sm-12">
                <div className="mb-3">
                  <label className="form-label" htmlFor="BodyHtml">Body Html<span className="text-danger">*</span></label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ri-flower-line" />
                    </span>
                    <textarea type="email" className="form-control" id="BodyHtmls" placeholder="Body HTML" title="HTML body (if formatted email)" row={2} />
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="ApiToken">Api Token <span className="text-danger">*</span></label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ri-flower-line" />
                    </span>
                    <input type="text" className="form-control" id="ApiTokens" placeholder="api Tokens" title="Api Tokens" />
                  </div>
                </div>
              </div>
              <div className="col-xxl-3 col-lg-4 col-sm-6">
                <div className="mb-3">
                  <label className="form-label" htmlFor="ccEmail">CC Mail <span className="text-danger">*</span></label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ri-flower-line" />
                    </span>
                    <input type="text" className="form-control" id="toEmails" placeholder="To mail" title="Sender email address (e.g., your business email)" />
                  </div>
                </div>
              </div>
              <div className="d-flex gap-2 justify-content-end">
                <button type="button" className="btn btn-secondary">
                  Cancel
                </button>
                <button type="button" className="btn btn-primary">
                  Update
                </button>
              </div>
            </div>
            {/* Row ends */}
          </div>
        );
      case 'sms':
        return (
          <div>
            <h5>SMS Settings</h5>
            <input type="text" placeholder="Sender ID" />
            {/* Add SMS fields */}
          </div>
        );
      case 'payment':
        return (
          <div>
            <h5>Payment Gateway Settings</h5>
            <input type="text" placeholder="Merchant Key" style={{ marginBottom: "10px" }} />
            {/* Add payment fields */}
            <div className="row gx-4">
              <div className="col-12">
                <div className="table-outer mb-3">
                  <div className="table-responsive">
                    <table className="table truncate align-middle m-0">
                      <thead>
                        <tr>
                          <th>Bank Name</th>
                          <th>Card Number</th>
                          <th>Card type</th>
                          <th>Expiry Date</th>
                          <th>Credit Balance</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Discover It Cash Back</td>
                          <td>
                            <span className="badge bg-primary text-white">0000 0000 0000 0000</span>
                          </td>
                          <td>Visa</td>
                          <td>20/10/2026</td>
                          <td>$100000</td>
                          <td>
                            <div className="form-check form-switch m-0">
                              <input className="form-check-input" type="checkbox" role="switch" id="cardActive" defaultChecked />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Capital One Quicksilver Card</td>
                          <td>
                            <span className="badge bg-success text-white">0000 0000 0000 0000</span>
                          </td>
                          <td>Master</td>
                          <td>02/24/2028</td>
                          <td>$150000</td>
                          <td>
                            <div className="form-check form-switch m-0">
                              <input className="form-check-input" type="checkbox" role="switch" id="cardActive2" defaultChecked />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Bank of America Rewards Card</td>
                          <td>
                            <span className="badge bg-warning text-white">0000 0000 0000 0000</span>
                          </td>
                          <td>Visa</td>
                          <td>05/09/2028</td>
                          <td>$50000</td>
                          <td>
                            <div className="form-check form-switch m-0">
                              <input className="form-check-input" type="checkbox" role="switch" id="cardActive3" defaultChecked />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Chase Freedom Unlimited</td>
                          <td>
                            <span className="badge bg-danger text-white">0000 0000 0000 0000</span>
                          </td>
                          <td>Discover</td>
                          <td>08/20/2027</td>
                          <td>$100000</td>
                          <td>
                            <div className="form-check form-switch m-0">
                              <input className="form-check-input" type="checkbox" role="switch" id="cardActive4" defaultChecked />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Blue Cash Everyday Card</td>
                          <td>
                            <span className="badge bg-dark text-white">0000 0000 0000 0000</span>
                          </td>
                          <td>Visa</td>
                          <td>24/10/2029</td>
                          <td>$90000</td>
                          <td>
                            <div className="form-check form-switch m-0">
                              <input className="form-check-input" type="checkbox" role="switch" id="cardActive5" />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>Wells Fargo Active Card</td>
                          <td>
                            <span className="badge bg-info text-white">0000 0000 0000 0000</span>
                          </td>
                          <td>Visa</td>
                          <td>25/05/2030</td>
                          <td>$75000</td>
                          <td>
                            <div className="form-check form-switch m-0">
                              <input className="form-check-input" type="checkbox" role="switch" id="cardActive6" />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="d-flex gap-2 justify-content-end">
                <button type="button" className="btn btn-secondary">
                  Cancel
                </button>
                <button type="button" className="btn btn-primary">
                  Update
                </button>
              </div>
            </div>
          </div>

        );
      default:
        return <p>Please select a module from dropdown.</p>;
    }
  };

    
  return(   
<div>
  {/* App hero header starts */}
  <div className="app-hero-header d-flex align-items-center">
    {/* Breadcrumb starts */}
    <ol className="breadcrumb">
      <li className="breadcrumb-item">
        <a href="#!">
          <i className="ri-home-3-line" />
        </a>
      </li>
      <li className="breadcrumb-item text-primary" aria-current="page">
        Company Settings
      </li>
    </ol>
    {/* Breadcrumb ends */}
    {/* Sales stats starts */}
    <div className="ms-auto d-lg-flex d-none flex-row">
      <div className="input-group">
      <span className="input-group-text">
                            <i className="ri-account-circle-line" />
                          </span>
                          <select className="form-select" id="a2"
                         value={comFetchId}
                         onChange={handleCompanyChange}>
                            <option value={0}>Select</option>
                           {companies.map((company)=>(<option 
                           value={company.companyId}>{company.companyName}
                           </option>))}
                          </select>
      </div>
    </div>
    {/* Sales stats ends */}
  </div>
  {/* App Hero header ends */}
  {/* App body starts */}
  <div className="app-body">
    {/* Row starts */}
    <div className="row gx-4">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            {/* Custom tabs starts */}
            {comFetchId>0 &&(
            <div className="custom-tabs-container">
              {/* Nav tabs starts */}
              <ul className="nav nav-tabs" id="customTab2" role="tablist">
                <li className="nav-item" role="presentation">
                  <a className="nav-link active" id="tab-oneA" data-bs-toggle="tab" href="#oneA" role="tab" aria-controls="oneA" aria-selected="true">
                    <i className="ri-profile-line" />
                    Basic
                    Details</a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" id="tab-twoA" data-bs-toggle="tab" href="#twoA" role="tab" aria-controls="twoA" aria-selected="false">
                    <i className="ri-alert-line" /> Module Settings</a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" id="tab-threeA" data-bs-toggle="tab" href="#threeA" role="tab" aria-controls="threeA" aria-selected="false">
                    <i className="ri-bank-card-line" /> Notification Settings
                    </a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" id="tab-fourA" data-bs-toggle="tab" href="#fourA" role="tab" aria-controls="fourA" aria-selected="false"><i className="ri-lock-password-line" /> Reset
                    Password</a>
                </li>
                <li className="nav-item" role="presentation">
                  <a className="nav-link" id="tab-fiveA" data-bs-toggle="tab" href="#fiveA" role="tab" aria-controls="fiveA" aria-selected="false"><i className="ri-settings-5-line" />
                    Api Settings</a>
                </li>
              </ul>
              {/* Nav tabs ends */}
              {/* Tab content starts */}
              
                <div className="tab-content h-350">
                <div className="tab-pane fade show active" id="oneA" role="tabpanel">
                  {/* Row starts */}
                  <form onSubmit={handleEdit} encType="multipart/form-data">
                  <div className="row gx-4">
                  <div className="col-xxl-12 col-lg-12 col-sm-12">
                        <div className="mb-12">
                            <h6>Basic Info</h6>
                            <hr/>
                        </div>
                    </div>
                    <div class="col-xxl-9 col-lg-9 col-sm-9">
                      <div class="row">
                    <div className="col-xxl-3 col-lg-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a1">Company Name <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-account-circle-line" />
                          </span>
                          <input type="text" className="form-control" id="a1" placeholder="Company Name"
                          value={editCompanyName} 
                          onChange={(e) => setEditCompanyName(e.target.value)} />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a2">Company Type <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-account-circle-line" />
                          </span>
                          <select className="form-select" id="a2"
                          value={editComTypeId}
                          onChange={handleDropdownChange}>
                             <option value={0}>Select</option>
                            {companyTypes.map((comType)=>(<option 
                            value={comType.companyTypeId}>{comType.companyTypeName}
                            </option>))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a31">Company Id  <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-flower-line" />
                          </span>
                          <input type="text" className="form-control" id="a31" placeholder="Prefix eg. WT" disabled
                          value={editCompanyIdPrefix} 
                          onChange={(e) => setEditCompanyIdPrefix(e.target.value)}/>
                          <input type="text" className="form-control" id="a32" placeholder="Id eg. 1001" disabled
                          value={editCompanyIdNo} 
                          onChange={(e) => setEditCompanyIdNo(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a4">Registration No /Lisence No <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-flower-line" />
                          </span>
                          <input type="text" className="form-control" id="a4" placeholder="Registration No"
                          value={editCompanyRegNo} 
                          onChange={(e) => setEditCompanyRegNo(e.target.value)} />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="gstno">Gst/ Tax ID<span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-flower-line" />
                          </span>
                          <input type="text" className="form-control" id="a5" placeholder="Gst No" name="gstno"
                          value={editCompanyGstNo} 
                          onChange={(e) => setEditCompanyGstNo(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-6 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a4">Logo /Branding <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-secure-payment-line" />
                          </span>
                          <input type="file" className="form-control" id="a6" 
                          ref={fileInputRef}
                          placeholder="Choose file" 
                          onChange={handleFileChange}/>
                        </div>
                      </div>
                    </div>
                    </div>
                    </div>
                    <div class="col-sm-3">
                    <div className="col-xxl-12 col-lg-12 col-sm-12">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a4">Preview <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <img src={`http://localhost:8080/webnet-hms/api/uploads/company/${bufferLogoImg}`} 
                          style={{width:"85%",height:"185px",margin:"auto"}} alt="logo/branding"/>
                        </div>
                      </div>
                    </div>
                    </div>
                    <div className="col-xxl-12 col-lg-12 col-sm-12">
                        <div className="mb-12">
                            <h6>Contact & Address Info</h6>
                            <hr/>
                        </div>
                    </div>
                    <div className="col-xxl-12 col-lg-12 col-sm-12">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a7">Head Office Address <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-mail-open-line" />
                          </span>
                          
                          <textarea className="form-control" id="a7" placeholder="office Address" rows={2}
                           defaultValue={""} required
                           value={editOfficeAddress} 
                          onChange={(e) => setEditOfficeAddress(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a8">Branch Locations <span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-phone-line" />
                          </span>
                          <input type="text" className="form-control" id="a8" placeholder="Branch Locations"
                            value={editBranchLocation} 
                            onChange={(e) => setEditBranchLocation(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a9">Phone Number</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-phone-line" />
                          </span>
                          <input type="text" className="form-control" id="a9" placeholder="Phone Numbers"
                          value={editPhoneNumber} 
                          onChange={(e) => setEditPhoneNumber(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a10">Email address</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-phone-line" />
                          </span>
                          <input type="email" className="form-control" id="a10" placeholder="Email Address"
                          value={editEmailAddress} 
                          onChange={(e) => setEditEmailAddress(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a11">Wesbsite Url</label>
                        {/* <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-nft-line" />
                          </span>
                          <select className="form-select" id="a9">
                            <option value={0}>Select</option>
                            <option value={1}>Doctor</option>
                            <option value={2}>Head of the Dept</option>
                          </select>
                        </div> */}
                                <div className="input-group">
                                  <span className="input-group-text">
                                    <i className="ri-phone-line" />
                                  </span>
                                  <input type="text" className="form-control" id="a11" placeholder="www@example.com"
                                    value={editWebsiteUrl}
                                    onChange={(e) => setEditWebsiteUrl(e.target.value)} />
                                </div>

                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a12">Emergency Contact<span className="text-danger">*</span></label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-phone-line" />
                          </span>
                          <input type="text" className="form-control" id="a12" placeholder="www@example.com"
                          value={editEmergencyContact} 
                          onChange={(e) => setEditEmergencyContact(e.target.value)}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-12 col-lg-12 col-sm-12">
                        <div className="mb-12">
                            <h6>Authorized Personnal</h6>
                            <hr/>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a13">Primary Contact Person</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-projector-line" />
                          </span>
                          <input type="text" className="form-control" id="a13" placeholder="Contact Info"
                          value={editPrimaryPerson} 
                          onChange={(e) => setEditPrimaryPerson(e.target.value)} />
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a14">Designation/Role</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-flag-line" />
                          </span>
                          <select className="form-select" id="a14"
                         value={editRolesId}
                         onChange={handleRoleChange}>
                          <option value={0}>Select</option>
                           {roles.map((role)=>(<option 
                           value={role.rolesId}>{role.roleName}
                           </option>))}
                    
                            
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-3 col-lg-4 col-sm-6">
                      <div className="mb-3">
                        <label className="form-label" htmlFor="a15">Contact Info</label>
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="ri-projector-line" />
                          </span>
                          <input type="text" className="form-control" id="a15" placeholder="Contact No"
                          value={editPriPersonContactNo} 
                          onChange={(e) => setEditPriPersonContactNo(e.target.value)} />
                        </div>
                      </div>
                    </div>
                    <div className="d-flex gap-2 justify-content-end">
              <button type="button" className="btn btn-secondary">
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Update
              </button>
            </div>               
                  </div>
                  </form>
                  {/* Row ends */}
                </div>
                <div className="tab-pane fade" id="twoA" role="tabpanel">
                  {/* Row starts */}
                  
                  <div className="row gx-4 justify-content-center">
                    <div className="col-sm-8 col-12">
                      <div>
                        <h5>Module Settings</h5>
                        <p>Defines working hours, available departments, offered services, staff structure, supported languages, and currency settings to tailor daily hospital operations efficiently.</p>
                      </div>
                      
                      <div className="list-group w-auto mb-5">
                      {modules.map((mod) => (
                        <div key={mod.companyModuleId} className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className={mod.moduleIcon+" text-dark fs-5"} />
                          </div>
                          <div>
                            <h6>{mod.moduleName}</h6>
                            <p className="m-0">
                              {mod.moduleDesc}
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n1"
                            defaultChecked={mod.isActive === 'Y' ? true : false}
                            onChange={(e) => {
                              if(mod.isActive==='Y'){
                                handleToggle(mod.companyModuleId,'N');
                              }else{
                                handleToggle(mod.companyModuleId,'Y');
                              }
                            }}
                             />
                          </div>
                        </div>
                        /* <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className="ri-phone-line text-dark fs-5" />
                          </div>
                          <div>
                            <h6>Appointments</h6>
                            <p className="m-0">
                              You can update new appointment notifications here.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n1" defaultChecked />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className="ri-mail-send-line text-dark fs-5" />
                          </div>
                          <div>
                            <h6>Prescriptions</h6>
                            <p className="m-0">
                              You can give priscriptions.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n2" defaultChecked />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className="ri-star-line text-dark fs-5" />
                          </div>
                          <div>
                            <h6>Bills</h6>
                            <p className="m-0">
                              You can give the bills.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n3" defaultChecked />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className="ri-radio-2-line text-dark fs-5" />
                          </div>
                          <div>
                            <h6>Stocks &amp; inventory</h6>
                            <p className="m-0">
                              You can manage stocks and inventories.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n4" />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className="ri-macbook-line text-dark fs-5" />
                          </div>
                          <div>
                            <h6>OPD</h6>
                            <p className="m-0">
                              Enable OPD editions facilities.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n5" />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className="ri-mail-send-line text-dark fs-5" />
                          </div>
                          <div>
                            <h6>IPD</h6>
                            <p className="m-0">
                              Enable IPD facilities.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n6" defaultChecked />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className="ri-chat-1-line text-dark fs-5" />
                          </div>
                          <div>
                            <h6>Pathology</h6>
                            <p className="m-0">
                              Enable pathologies sevices.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n7" defaultChecked />
                          </div>
                        </div>
                        <div className="list-group-item d-flex align-items-center gap-3 py-3">
                          <div className="icon-box lg bg-secondary rounded-3">
                            <i className="ri-emoji-sticker-line text-dark fs-5" />
                          </div>
                          <div>
                            <h6>Blood Tests</h6>
                            <p className="m-0">
                              Enable blood test services.
                            </p>
                          </div>
                          <div className="form-check form-switch m-0 ms-auto">
                            <input className="form-check-input" type="checkbox" role="switch" id="n8" defaultChecked />
                          </div>
                        </div> */
                      ))}
                      </div>
                    
                    </div>
                  </div>
                  
                  {/* Row ends */}
                </div>
                <div className="tab-pane fade" id="threeA" role="tabpanel">
                  {/* Row starts */}
                  <div className="row gx-4 justify-content-center">
  <div className="col-sm-8 col-12">
    <div>
      <h5>Notification Preferences</h5>
      <p>While you are not around, check your emails to see what is happening. You can disable
        these. Update your notifications here.</p>
    </div>
    
    <div className="list-group w-auto mb-5">
    {notis.map((not) => (
      <div key={not.companyNotiId} className="list-group-item d-flex align-items-center gap-3 py-3">
        <div className="icon-box lg bg-secondary rounded-3">
          <i className={not.notiIcon+" text-dark fs-5"} />
        </div>
        <div>
          <h6>{not.notiName}</h6>
          <p className="m-0">
           {not.notiDesc}
          </p>
        </div>
        <div className="form-check form-switch m-0 ms-auto">
          <input className="form-check-input" type="checkbox" role="switch" id="noti1" 
          defaultChecked={not.isActive === 'Y' ? true : false}
          onChange={(e) => {
            if(not.isActive==='Y'){
              handleNotiToggle(not.companyNotiId,'N');
            }else{
              handleNotiToggle(not.companyNotiId,'Y');
            }
          }}
          
          />
        </div>
      </div>
      /* <div className="list-group-item d-flex align-items-center gap-3 py-3">
        <div className="icon-box lg bg-secondary rounded-3">
          <i className="ri-phone-line text-dark fs-5" />
        </div>
        <div>
          <h6>New Appointment</h6>
          <p className="m-0">
            You can update new appointment notifications here.
          </p>
        </div>
        <div className="form-check form-switch m-0 ms-auto">
          <input className="form-check-input" type="checkbox" role="switch" id="n1" defaultChecked />
        </div>
      </div>
      <div className="list-group-item d-flex align-items-center gap-3 py-3">
        <div className="icon-box lg bg-secondary rounded-3">
          <i className="ri-mail-send-line text-dark fs-5" />
        </div>
        <div>
          <h6>New Messages</h6>
          <p className="m-0">
            You can update your messages notifications here.
          </p>
        </div>
        <div className="form-check form-switch m-0 ms-auto">
          <input className="form-check-input" type="checkbox" role="switch" id="n2" defaultChecked />
        </div>
      </div>
      <div className="list-group-item d-flex align-items-center gap-3 py-3">
        <div className="icon-box lg bg-secondary rounded-3">
          <i className="ri-star-line text-dark fs-5" />
        </div>
        <div>
          <h6>New Review</h6>
          <p className="m-0">
            You can update review notifications here.
          </p>
        </div>
        <div className="form-check form-switch m-0 ms-auto">
          <input className="form-check-input" type="checkbox" role="switch" id="n3" defaultChecked />
        </div>
      </div>
      <div className="list-group-item d-flex align-items-center gap-3 py-3">
        <div className="icon-box lg bg-secondary rounded-3">
          <i className="ri-radio-2-line text-dark fs-5" />
        </div>
        <div>
          <h6>News &amp; Updates</h6>
          <p className="m-0">
            You can update your news and updates notifications here.
          </p>
        </div>
        <div className="form-check form-switch m-0 ms-auto">
          <input className="form-check-input" type="checkbox" role="switch" id="n4" />
        </div>
      </div>
      <div className="list-group-item d-flex align-items-center gap-3 py-3">
        <div className="icon-box lg bg-secondary rounded-3">
          <i className="ri-macbook-line text-dark fs-5" />
        </div>
        <div>
          <h6>Desktop Notifications</h6>
          <p className="m-0">
            Enable desktop notifications here.
          </p>
        </div>
        <div className="form-check form-switch m-0 ms-auto">
          <input className="form-check-input" type="checkbox" role="switch" id="n5" />
        </div>
      </div>
      <div className="list-group-item d-flex align-items-center gap-3 py-3">
        <div className="icon-box lg bg-secondary rounded-3">
          <i className="ri-mail-send-line text-dark fs-5" />
        </div>
        <div>
          <h6>Email Notifications</h6>
          <p className="m-0">
            Enable email notifications here.
          </p>
        </div>
        <div className="form-check form-switch m-0 ms-auto">
          <input className="form-check-input" type="checkbox" role="switch" id="n6" defaultChecked />
        </div>
      </div>
      <div className="list-group-item d-flex align-items-center gap-3 py-3">
        <div className="icon-box lg bg-secondary rounded-3">
          <i className="ri-chat-1-line text-dark fs-5" />
        </div>
        <div>
          <h6>Chat Notifications</h6>
          <p className="m-0">
            Enable chat notification here.
          </p>
        </div>
        <div className="form-check form-switch m-0 ms-auto">
          <input className="form-check-input" type="checkbox" role="switch" id="n7" defaultChecked />
        </div>
      </div>
      <div className="list-group-item d-flex align-items-center gap-3 py-3">
        <div className="icon-box lg bg-secondary rounded-3">
          <i className="ri-emoji-sticker-line text-dark fs-5" />
        </div>
        <div>
          <h6>New Follower</h6>
          <p className="m-0">
            Enable or disable for new followers.
          </p>
        </div>
        <div className="form-check form-switch m-0 ms-auto">
          <input className="form-check-input" type="checkbox" role="switch" id="n8" defaultChecked />
        </div>
      </div>
      <div className="list-group-item d-flex align-items-center gap-3 py-3">
        <div className="icon-box lg bg-secondary rounded-3">
          <i className="ri-time-line text-dark fs-5" />
        </div>
        <div>
          <h6>Reminders</h6>
          <p className="m-0">
            Set your reminders here.
          </p>
        </div>
        <div className="form-check form-switch m-0 ms-auto">
          <input className="form-check-input" type="checkbox" role="switch" id="n9" />
        </div>
      </div>
      <div className="list-group-item d-flex align-items-center gap-3 py-3">
        <div className="icon-box lg bg-secondary rounded-3">
          <i className="ri-message-3-line text-dark fs-5" />
        </div>
        <div>
          <h6>Comments</h6>
          <p className="m-0">
            Comment on your post and replies to comments.
          </p>
        </div>
        <div className="form-check form-switch m-0 ms-auto">
          <input className="form-check-input" type="checkbox" role="switch" id="n10" defaultChecked />
        </div>
      </div> */
       ))}
    </div>
   
  </div>
</div>

                        {/* Row ends */}
                      </div >
                      <div className="tab-pane fade" id="fourA" role="tabpanel">
                        {/* Row starts */}
                        <div className="row justify-content-center">
                          <div className="col-sm-4 col-12">
                            <div className="card border mb-3">
                              <div className="card-body">
                                <div className="mb-3">
                                  <label className="form-label" htmlFor="currentPwd">Current password <span className="text-danger">*</span></label>
                                  <div className="input-group">
                                    <input type="password" id="currentPwd" placeholder="Enter Current password" className="form-control" />
                                    <button className="btn btn-outline-secondary" type="button">
                                      <i className="ri-eye-line text-black" />
                                    </button>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <label className="form-label" htmlFor="newPwd">New password <span className="text-danger">*</span></label>
                                  <div className="input-group">
                                    <input type="password" id="newPwd" className="form-control" placeholder="Your password must be 8-20 characters long." />
                                    <button className="btn btn-outline-secondary" type="button">
                                      <i className="ri-eye-line text-black" />
                                    </button>
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <label className="form-label" htmlFor="confNewPwd">Confirm new password <span className="text-danger">*</span></label>
                                  <div className="input-group">
                                    <input type="password" id="confNewPwd" placeholder="Confirm new password" className="form-control" />
                                    <button className="btn btn-outline-secondary" type="button">
                                      <i className="ri-eye-off-line text-black" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex gap-2 justify-content-end">
                            <button type="button" className="btn btn-secondary">
                              Cancel
                            </button>
                            <button type="button" className="btn btn-primary">
                              Update
                            </button>
                          </div>
                        </div>
                        {/* Row ends */}
                      </div>
                      <div className="tab-pane fade" id="fiveA" role="tabpanel">
                        {/* Row starts */}
                        <div className="row justify-content-left">
                          <div className="col-sm-12 col-12">
                            <div className="card border mb-3">
                              <div className="col-sm-12">
                                <div className="card-body">
                                  <div className="col-sm-3 col-12 mb-3">
                                    <label className="form-label" htmlFor="currentPwd">Api Settings Modules <span className="text-danger">*</span></label>
                                    <div className="input-group">
                                      <span className="input-group-text">
                                        <i className="ri-account-circle-line" />
                                      </span>
                                      <select className="form-select" id="a22" onChange={(e) => setSelectedTab(e.target.value)}>
                                        <option value="">-- Select Module --</option>
                                        <option value="whatsapp">WhatsApp</option>
                                        <option value="email">E-Mail</option>
                                        <option value="sms">SMS</option>
                                        <option value="payment">Payment Gateway</option>
                                      </select>

                                    </div>
                                  </div>
                                  <div className="col-sm-12 col-12">
                                    <div class="tab-content h-350">
                                      {renderTabContent()}

                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                        {/* Row ends */}
                      </div>
                    </div >


                    {/* Tab content ends */}
                  </div >
                )}
                {/* Custom tabs ends */}
                {/* Buttons starts */}

                {/* Buttons ends */}
              </div >
            </div >
          </div >
        </div >
        {/* Row ends */}
      </div >
      {/* App body ends */}
    </div >


  );
}
export default CompanySetting;




